import { render, staticRenderFns } from "./storeDetail2.vue?vue&type=template&id=62af3a36&scoped=true&"
import script from "./storeDetail2.vue?vue&type=script&lang=js&"
export * from "./storeDetail2.vue?vue&type=script&lang=js&"
import style0 from "./storeDetail2.vue?vue&type=style&index=0&id=62af3a36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62af3a36",
  null
  
)

export default component.exports